import {ChipType} from '@web-catalog/types';

export const getItemPropForChipType = (type: ChipType) => {
  if (type === 'categories') {
    return 'applicationCategory';
  }
  return 'applicationLabel';
};

export const a11yLabelsForChipTypes: Record<ChipType, string> = {
  categories: 'Категория',
  labels: 'Метка',
  tags: 'Тег',
  TVMode: 'Тег',
};
